<template>
  <div id="reviewModal" class="modal" :class="{ 'is-active': active }">
    <div class="modal-background" @click="closeReviewModal()"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Leave a review for {{ gym_name }}</p>
        <button
          class="delete"
          aria-label="close"
          @click="closeReviewModal()"
        ></button>
      </header>
      <section class="modal-card-body">
        <input
          class="input mb-4"
          type="text"
          placeholder="Name"
          
          v-model="review.name"
        />
        <input
          class="input mb-4"
          type="text"
          placeholder="Email"
          
          v-model="review.email"
        />
        <p
          class="rating ratingWord"
        >
          Rating:
        </p>
        <RatingStars
          class="rating mb-4"
          :editable="true"
          @saveRating="updateRating"
          v-if="active"
        />

        <textarea
          class="textarea input"
          type="text"
          placeholder="Your review"
          v-model="review.content"
        ></textarea>
        <h3 class="errorMessage">{{ errorMessage || '' }}</h3>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button search-button slide-left ml-4"
          @click="confirmReview()"
        >
          Send Review
        </button>
        <button
          class="button is-rounded range-button has-text-centered"
          @click="closeReviewModal()"
        >
          Cancel
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import RatingStars from '../atoms/RatingStars';
export default {
  components: {
    RatingStars,
  },
  data() {
    return {
      review: {
        name: undefined,
        rating: 0,
        content: undefined,
        email: undefined,
      },
      rating: undefined,
      errorMessage: undefined,
    };
  },
  methods: {
    closeReviewModal() {
      this.review = {
        name: undefined,
        rating: 0,
        content: undefined,
        email: undefined,
      };
      this.errorMessage = undefined;
      this.$emit('closeReviewModal');
    },
    updateRating(rating) {
      this.review.rating = rating;
    },
    async confirmReview() {
      try {
        let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (this.review.name && this.review.content) {
          if (emailRegex.test(this.review.email)) {
            if (this.review.rating !== 0) {
              this.review.gym_id = this.gym_id
              let response = await this.$http.post(
                `/api/reviews/`,
                this.review
              );
              if (response.status === 200) {
                this.$store.dispatch('showNotification');
                this.closeReviewModal();
              }
            } else {
              this.errorMessage = 'Please select a rating';
            }
          } else {
            this.errorMessage = 'Invalid email';
          }
        } else {
          this.errorMessage = 'Please fill in empty fields';
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  props: {
    gym_id: Number,
    gym_name: String,
    active: Boolean,
  },
};
</script>

<style scoped>
.rating {
  display: inline-block;
}

.errorMessage {
  font-size: 1rem; 
  color: red;
}

.modal-card,
.modal-card-foot {
  padding: 0.5rem;
}

.modal {
  z-index:1000;
}
</style>
